import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import useSnackbar from '../../../hooks/useSnackbar';
import { getTransactionSalesOrderAvatax } from '../../../api/transaction-type';
import { salesOrderAvaTaxTable } from '../../../config/grid-column-defs';
import AgGridPaginatedTable from '../../../components/AgGridPaginatedTable';
import { slugMap } from '../../../config/slug-config';
import { useParams } from 'react-router-dom';
import { Box, Grid, Tabs, Tab, CircularProgress } from '@mui/material';
import TabPanel from "../../../components/TabPanel";

export default function CreditMemoAvaTax({ tabIndexP }) {

  const snackbar = useSnackbar();
  const { data: user } = useSelector(state => state.user);
  const params = useParams();
  const [loading, setLoading] = useState(false);
  const [rowData, setRowData] = useState([]);
  const [subtabIndex, setSubtabIndex] = useState(0);

  const pageDetail = slugMap[params.slug];

  useEffect(() => {
    if (user.token) {
      getTransactionAvataxLogData();
    }
  }, []); 

  async function getTransactionAvataxLogData(limit = 10, offset = 0) {
    try {
      setLoading(true); 
      const { data } = await getTransactionSalesOrderAvatax(user.token, {
        id: params.docNo,
        limit,
        offset,
      });
      setRowData(data.data ); 
      return { rows: data.data.data, total: data.data.total, error: false, };
    } catch (error) {
      console.error(error);
      snackbar.showError("Error In Loading Data.");
    } finally {
      setLoading(false); 
    }
  }
console.log(rowData,"row")
  return (
    <>
      {loading ? (
        <Box className="viewBox">
          <Box className="viewDetilsBox">
            <Grid container className="mb-2">
              <Grid item xs={12}>
                <div style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                  <CircularProgress />
                </div>
              </Grid>
            </Grid>
          </Box>
        </Box>
      ) : (
        <Box className="viewDetilsBox">
         
            <Grid container className="mb-2">

              <Grid item xs={12} sm={6} md={6} className="m-b-10">
                <p className="tFormlabel">AVATAX DOCUMENT NUMBER</p>
                <p className="tFormName">{rowData?.avatax_document_number}</p>
              </Grid>
              <Grid item xs={12} sm={6} md={6} className="m-b-10">
                <p className="tFormlabel">TOTAL DISCOUNT</p>
                <p className="tFormName">{rowData?.total_discount}</p>
              </Grid>

              <Grid item xs={12} sm={6} md={6} className="m-b-10">
                <p className="tFormlabel">DOCUMENT DATE</p>
                <p className="tFormName">{rowData?.document_date}</p>
              </Grid>
              <Grid item xs={12} sm={6} md={6} className="m-b-10">
                <p className="tFormlabel">TOTAL NON-TAXABLE</p>
                <p className="tFormName">{rowData?.total_non_taxable}</p>
              </Grid>
              <Grid item xs={12} sm={6} md={6} className="m-b-10">
                <p className="tFormlabel">DOCUMENT STATUS</p>
                <p className="tFormName">{rowData?.document_status}</p>
              </Grid>
              <Grid item xs={12} sm={6} md={6} className="m-b-10">
                <p className="tFormlabel">TOTAL TAXABLE</p>
                <p className="tFormName">{rowData?.total_taxable}</p> 
              </Grid>
              <Grid item xs={12} sm={6} md={6} className="m-b-10">
                <p className="tFormlabel">TAX CALCULATION DATE</p>
                <p className="tFormName">{rowData?.tax_calculation_date}</p>
              </Grid>
              <Grid item xs={12} sm={6} md={6} className="m-b-10">
                <p className="tFormlabel">TOTAL TAX</p>
                <p className="tFormName">{rowData?.total_tax}</p>
              </Grid>
              <Grid item xs={12} sm={6} md={6} className="m-b-10">
                <p className="tFormlabel">TOTAL AMOUNT</p>
                <p className="tFormName">{rowData?.total_amount}</p>
              </Grid>
            </Grid>
         
        </Box>
      )}

      <Box className="viewBox sub-tab" sx={{ maxWidth: { xs: 320, sm: 480, md: "100%" }, bgcolor: '#fff' }}>
        <Tabs
          value={subtabIndex}
          onChange={(e, nv) => {
            setSubtabIndex(nv);
          }}
          variant="scrollable"
          scrollButtons="auto"
          aria-label="scrollable auto tabs example"
          className="tabs-bkg1"
        >
          <Tab label="Logs" />
        </Tabs>

        {/* avatax log */}
        <TabPanel value={subtabIndex} index={0}>
          {tabIndexP === 10 ? (
            <AgGridPaginatedTable
              getTableRows={getTransactionAvataxLogData}
              columns={salesOrderAvaTaxTable}
              perPage={10}
              refreshCounter={0}
            />
          ) : (
            <></>
          )}
        </TabPanel>
        {/* avatax log */}
      </Box>
    </>
  );
}
